<mat-toolbar class="subtitulo">Relatórios - Financeiro</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Selecione o tipo do relatório</mat-label>
                    <mat-select required
                                [(ngModel)]="tipoRelatorioSelecionado" 
                                name="tipoRelatorioSelecionado"
                                (selectionChange)="carregarTipoRelatorio()">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of tiposRelatorios" [value]="d">
                            {{d.descricao.toUpperCase()}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="tipoRelatorioSelecionado">

                <div fxLayout="row" fxLayoutGap="50px" style="padding-top: 10px !important;" fxFlexFill *ngIf="showFiltroCategoria()">
                    <div ngModelGroup="comboRubrica" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                        <combo-pesquisavel #comboRubrica 
                                           nome="rubrica" 
                                           [itens]="comboPlanosContas" 
                                           itemDescricao="planoConta"
                                           itemId="id"
                                           label="Conta Contábil"
                                           placeholder="Escolha..."
                                           [(valor)]="filtro.planoConta"
                                           (valorChange)="limparSaldoContaContabil()"
                                           style="margin-top: 10px;">
                        </combo-pesquisavel>
                    </div>
                    
                    <div style="margin-top: 50px;" *ngIf="showFiltroRubricaAdicional()">
                        <div style="margin-top: 25px;">
                            <mat-checkbox  name="rubricaAdicional" [(ngModel)]="filtro.rubricaAdicional">Rubrica adicional</mat-checkbox>
                        </div>
                    </div>  
                    
                </div>


                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill *ngIf="showFiltroContaBancaria()">
                    
                    <div ngModelGroup="comboContaBancaria" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                        <combo-pesquisavel #comboContaBancaria 
                                           nome="contaBancaria" 
                                           [itens]="comboContasBancarias" 
                                           itemDescricao="descricaoCompleta"
                                           itemId="id"
                                           label="Agência - Conta Corrente"
                                           placeholder="Escolha..."
                                           [(valor)]="filtro.contaBancaria"
                                           style="margin-top: 10px;">
                        </combo-pesquisavel>
                    </div> 
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                    <div fxFlex="none" style="display: flex; align-items: center;" *ngIf="showFiltroDataVencimento()">
                        <mat-checkbox
                        (change)="atualizarCheckRecebimentos()"
                        color="primary" 
                        name="checkRecebimentos" 
                        [(ngModel)]="checkRecebimentos" 
                        class="custom-checkbox"
                        style="margin: 0 30px 0 15px;">
                        Recebimentos
                        </mat-checkbox>
                    </div>

                    <div fxFlex="none" style="display: flex; align-items: center;" *ngIf="showFiltroDataVencimento()">
                        <mat-checkbox
                        (change)="atualizarCheckPagamentos()"
                        color="primary" 
                        name="checkPagamentos" 
                        [(ngModel)]="checkPagamentos" 
                        class="custom-checkbox"
                        style="margin: 0 30px 0 15px;">
                        Pagamentos
                        </mat-checkbox>
                    </div>
                    <div ngModelGroup="comboProjeto" fxLayout="column" fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                        <combo-pesquisavel #comboProjeto 
                                            nome="projeto" 
                                            [itens]="comboProjetos" 
                                            itemDescricao="nome"
                                            itemId="id"
                                            label="Projeto"
                                            placeholder="Escolha..."
                                            [(valor)]="filtro.projeto"
                                            (valorChange)="carregarProjeto($event)"
                                            style="margin-top: 10px;">
                        </combo-pesquisavel>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill *ngIf="showFiltroFornecedor()">
                    <div ngModelGroup="comboPessoaFisica" fxLayout="column" fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                        <combo-pessoa-fisica    label="Fornecedor / Cliente (Pessoa Física)"
                                                [fxFlexOffset]="0"
                                                [selecionado]="filtro.pessoaFisica"
                                                (valorChange)="limparFiltroEmpresa($event)">
                        </combo-pessoa-fisica>
                    </div>

                    <div ngModelGroup="comboEmpresa" fxLayout="column" fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                        <combo-empresa    label="Fornecedor / Cliente Fornecedor (Pessoa Jurídica)"
                                          [fxFlexOffset]="0"
                                          [selecionado]="filtro.empresa"
                                          (valorChange)="limparFiltroPessoaFisica($event)">
                        </combo-empresa>
                    </div>                    

                </div>


                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                    <mat-form-field fxFlex= "150px" fxLayoutGap="20px" fxFlexOffset="20px">
                        <input matInput name= "dataInicio"
                                [matDatepicker]="dataInicio" 
                                placeholder="Data início" 
                                [required]="isRequiredFiltroData()"
                                [(ngModel)]="filtro.dataInicio"
                                (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicio></mat-datepicker>
                    </mat-form-field>
                
                    <mat-form-field fxFlex= "150px" >
                        <input matInput name="dataFim"
                                [matDatepicker]="dataFim" 
                                placeholder="Data fim" 
                                [required]="isRequiredFiltroData()"
                                [(ngModel)]="filtro.dataFim"
                                (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                        <mat-datepicker #dataFim></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex= "200px" fxLayoutGap="20px" fxFlexOffset="20px" *ngIf="showFiltroDataVencimento()">
                        <input matInput name= "dataInicioVenc"
                                [matDatepicker]="dataInicioVenc" 
                                placeholder="Data início Vencimento" 
                                [(ngModel)]="filtro.dataInicioVenc"
                                (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataInicioVenc"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicioVenc></mat-datepicker>
                    </mat-form-field>
                
                    <mat-form-field fxFlex= "200px" *ngIf="showFiltroDataVencimento()">
                        <input matInput name="dataFimVenc"
                                [matDatepicker]="dataFimVenc" 
                                placeholder="Data fim Vencimento" 
                                [(ngModel)]="filtro.dataFimVenc"
                                (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataFimVenc"></mat-datepicker-toggle>
                        <mat-datepicker #dataFimVenc></mat-datepicker>
                    </mat-form-field>

                </div>
    
                <div *ngIf="isRelatorioNormativaPagamento() && mostrarTabela" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                    <span fxFlexOffset="20px" style="font-weight: bold;">Valor Total Movimentação: </span> <label style="padding-left:5px">{{valorTotalMovimentos | currency: 'BRL'}}</label> 
                </div>

                <div *ngIf="isRelatorioFaturas() && mostrarTabela" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                    <span fxFlexOffset="20px" style="font-weight: bold;">Valor Total Movimentação: </span> <label style="padding-left:5px">{{valorTotalMovimentos | currency: 'BRL'}}</label> 
                    <span fxFlexOffset="20px" style="font-weight: bold;">Valor Total Fatura: </span> <label style="padding-left:5px">{{valorTotalFatura | currency: 'BRL'}}</label> 
                </div>

                <div fxLayout="row" *ngIf="isRelatorioMovimentacaoContabil() && isShowSaldoContabil()" 
                     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>

                    <span [ngStyle]="{'color': valorSaldoInicioMovimentos < 0 ? 'red' : '' }">
                        <label fxFlexOffset="20px" style="font-weight: bold;">Saldo Anterior:</label> 
                        <label style="padding-left:5px">{{valorSaldoInicioMovimentos | currency: 'BRL'}}</label>
                    </span>
                    <span [ngStyle]="{'color': valorTotalDestino < 0 ? 'red' : '' }">
                        <label fxFlexOffset="20px" style="font-weight: bold;">Total Destino:</label> 
                        <label style="padding-left:5px">{{valorTotalDestino | currency: 'BRL'}}</label>
                    </span>

                    <span [ngStyle]="{'color': valorTotalOrigem < 0 ? 'red' : '' }">
                        <label fxFlexOffset="20px" style="font-weight: bold;">Total Origem:</label> 
                        <label style="padding-left:5px">{{valorTotalOrigem | currency: 'BRL'}}</label>
                    </span>
                    <span [ngStyle]="{'color': valorTotalFinal < 0 ? 'red' : '' }">
                        <label fxFlexOffset="20px" style="font-weight: bold;">Saldo Final:</label> 
                        <label style="padding-left:5px">{{valorTotalFinal | currency: 'BRL'}}</label>
                    </span>
                </div>
    
                <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                    <button mat-raised-button fxFlex="150px" (click)="getRelatorio(MIMETYPE_PDF)" 
                            [ngStyle]="{'background-color' : mostrarTabela ? 'green' : ''}" 
                            style="color: rgb(252, 250, 250);" 
                            [fxHide]="!mostrarTabela">
                        GERAR PDF
                    </button>
    
                    <button mat-raised-button fxFlex="150px" 
                            (click)="getRelatorio(MIMETYPE_EXCEL)" 
                            [ngStyle]="{'background-color' : mostrarTabela ? 'green' : ''}" 
                            style="color: rgb(255, 254, 254);" 
                            [fxHide]="!mostrarTabela" >
                        GERAR EXCEL
                    </button>
    
                    <button mat-raised-button fxFlex="150px" (click)="consultar()" 
                            [disabled]="formulario.invalid">
                        CONSULTAR
                    </button>
    
                    <button mat-raised-button fxFlex="150px" style="padding-right: 20px" (click)="limpar()">
                        LIMPAR
                    </button>
                </div>
            </div>

        </form>



        <div [hidden]="!mostrarTabela" style="margin-top: 20px;">
            <mat-paginator #paginator [pageSizeOptions]="[50, 100, 150, 200, 300]" showFirstLastButtons></mat-paginator>
        </div>
        <table [fxHide]="!mostrarTabela" 
                matSort matSortDisableClear mat-table [dataSource]="dataSource">
                
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 20px">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(row) : null"
                                  [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            

            <ng-container matColumnDef="nomeProgramaProjeto" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Projeto</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeProgramaProjeto }} </td>
            </ng-container>

            <ng-container matColumnDef="nomeProjeto" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Projeto</th>
                <td mat-cell *matCellDef="let element"> 
                    <projeto-cell [projetos]="element.projetos"></projeto-cell>
                </td>
            </ng-container>

            <ng-container matColumnDef="fornecedor" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Fornecedor</th>
                <td mat-cell *matCellDef="let element"> {{element.descFornecedor }} </td>
            </ng-container>

            <ng-container matColumnDef="tipo" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 80px">Tipo</th>
                <td mat-cell *matCellDef="let element"> {{element.tipoTransacao }} </td>
            </ng-container>            

            <ng-container matColumnDef="descricao" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Descrição</th>
                <td mat-cell *matCellDef="let element"> {{element.descricao }} </td>
            </ng-container>           

            <ng-container matColumnDef="parceiro" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Parceiro</th>
                <td mat-cell *matCellDef="let element"> {{element.parceiro }} </td>
            </ng-container>            

            <ng-container matColumnDef="numerodocumento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 100px">N. documento</th>
                <td mat-cell *matCellDef="let element"> {{element.numeroDocumento }} </td>
            </ng-container>

            <ng-container matColumnDef="cnpjcpf">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 150px">CNPJ/CPF</th>
                <td mat-cell *matCellDef="let element"> {{element.cnpjCpf }} </td>
            </ng-container>

            <ng-container matColumnDef="dataoperacao">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 100px">Data operação</th>
                <td mat-cell *matCellDef="let element"> {{element.dataOperacao}} </td>
            </ng-container>            

            <ng-container matColumnDef="valoroperacao">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 100px">Valor operação</th>
                <td mat-cell *matCellDef="let element"> {{element.valorOperacao | currency: 'BRL'}} </td>
            </ng-container>            

            <ng-container matColumnDef="datadocumento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 120px">Data Movimentaçao</th>
                <td mat-cell *matCellDef="let element"> {{element.dataDocumento}} </td>
            </ng-container>            

            <ng-container matColumnDef="valormovimentacao">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 120px">Valor movimento</th>
                <td mat-cell *matCellDef="let element"> {{element.valorMovimentacao | currency: 'BRL'}} </td>
            </ng-container>            

            <ng-container matColumnDef="valorfatura">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 120px">Valor Fatura</th>
                <td mat-cell *matCellDef="let element"> {{element.valorFatura | currency: 'BRL'}} </td>
            </ng-container>            

            <ng-container matColumnDef="numerotransacao">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 120px">Nr Transação</th>
                <td mat-cell *matCellDef="let element"> {{element.numeroDocumentoPagamento}} </td>
            </ng-container>  

            <ng-container matColumnDef="datapagamento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 120px">Data pagamento</th>
                <td mat-cell *matCellDef="let element"> {{element.dataPagamento}} </td>
            </ng-container> 
            
            
            <ng-container matColumnDef="bancoagenciaconta">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Banco-Agência-Conta</th>
                <td mat-cell *matCellDef="let element"> {{element.banco + ' - ' + element.conta}} </td>
            </ng-container>  

            <ng-container matColumnDef="saldo">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 100px">Saldo</th>
                <td mat-cell *matCellDef="let element"> {{element.saldo | currency: 'BRL'}} </td>
            </ng-container> 

            <ng-container matColumnDef="datavencimento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 120px">Data vencimento</th>
                <td mat-cell *matCellDef="let element"> {{element.dataVencimento}} </td>
            </ng-container> 

            <ng-container matColumnDef="rubrica">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Conta Contábil {{filtro.rubricaAdicional ? ' Adicional': ''}}</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeCategoria}} </td>
            </ng-container>  

            <ng-container matColumnDef="contaContabil">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Conta Contábil</th>
                <td mat-cell *matCellDef="let element">
                    <categoria-contabil-cell [categorias]="element.categorias"></categoria-contabil-cell>
                </td>
            </ng-container>  

            <ng-container matColumnDef="descricaoCategoria">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 150px">Histórico da Movimentação</th>
                <td mat-cell *matCellDef="let element"> {{element.descricaoCategoria}} </td>
            </ng-container>  

            <ng-container matColumnDef="dataMovimentacao">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 120px">Data Movimentação</th>
                <td mat-cell *matCellDef="let element"> {{element.dataMovimentacao}} </td>
            </ng-container> 

            <ng-container matColumnDef="valorCategoria">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 100px">Valor Movimentação</th>
                <td mat-cell *matCellDef="let element"> {{element.valorCategoria | currency: 'BRL'}} </td>
            </ng-container> 

            <ng-container matColumnDef="contaDestino">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Conta Destino</th>
                <td mat-cell *matCellDef="let element"> {{element.contaDestino}} </td>
            </ng-container> 

            <ng-container matColumnDef="contaOrigem">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 300px">Conta Origem</th>
                <td mat-cell *matCellDef="let element"> {{element.contaOrigem}} </td>
            </ng-container> 

            <ng-container matColumnDef="acoes" stickyEnd>
                <th mat-header-cell *matHeaderCellDef style="width: 1%; margin-left: 5px"> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="abrirMovimentacao(element)" style="min-width: auto; padding: 0px">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row);"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator (page)="handlePageBottom($event)" 
                            [pageSize]="paginator.pageSize"
                            [pageIndex]="paginator.pageIndex" 
                            [length]="paginator.length"
                            [pageSizeOptions]="paginator.pageSizeOptions">
            </mat-paginator>
        </div>        
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px"
                [fxHide]="mostrarTabela" >
            {{msg}}
        </div>       

    </div>
</div>
